// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"413a89e8","826":"c16f1453"}[chunkId] + ".chunk.js";
};